import { Box, Stack, useMediaQuery } from "@mui/material";
import BankIdLoginFormEComp from "./BankIdLoginFormEComp";
import Translate from "../../../utils/Translate";
import { androidAppUrl, iosAppUrl } from "../../../utils/constants";

function AppLinks({ paddingTop }) {
  return (
    <Stack direction="row" spacing={1} paddingTop={paddingTop}>
      <a href={iosAppUrl} target="_blank" rel="noopener noreferrer">
        <img
          style={{ height: "40px" }}
          src="https://eportpublic.blob.core.windows.net/others/apple/get_on_apple_store_SE.svg?sp=r&st=2024-04-12T07:06:58Z&se=2064-04-12T15:06:58Z&spr=https&sv=2022-11-02&sr=c&sig=STfImuoPxA9srWpHhIHlMAaW7w9ST8G1CYcpsinC6PQ%3D"
        />
      </a>
      <a href={androidAppUrl} target="_blank" rel="noopener noreferrer">
        <img
          style={{ height: "40px" }}
          src="https://eportpublic.blob.core.windows.net/others/google/get_on_google_play_SE.png?sp=r&st=2024-04-12T07:06:58Z&se=2064-04-12T15:06:58Z&spr=https&sv=2022-11-02&sr=c&sig=STfImuoPxA9srWpHhIHlMAaW7w9ST8G1CYcpsinC6PQ%3D"
        />
      </a>
    </Stack>
  );
}

export default function LoginEComp({ onLoginSuccess, startQrCodeOnDesktop }) {
  const lessThan1000px = useMediaQuery("(max-width:1000px)");
  const smallHeight = useMediaQuery("(max-height:740px)");
  return (
    <>
      <Stack direction={lessThan1000px ? "column" : "row"} spacing={lessThan1000px ? 5 : 20} alignItems="center">
        <div
          className="loginBox"
          style={{
            padding: lessThan1000px ? "12px 48px" : "18px 80px",
            width: "100%",
            maxWidth: lessThan1000px ? "400px" : "480px",
          }}
        >
          <BankIdLoginFormEComp onLoginSuccess={onLoginSuccess} startQrCodeOnDesktop={startQrCodeOnDesktop} />
        </div>

        {!lessThan1000px && (
          <Stack direction="column" spacing={3} sx={{ color: "white" }}>
            <img src="/static/ecomp-logo-mini.png" style={{ width: "150px", height: "auto" }} />
            <h1>{Translate.get("ECompLoginInfoTitle")}</h1>
            <Box maxWidth={420} paddingTop="24px">
              {Translate.get("ECompLoginInfoSubtitle")}
            </Box>
            <AppLinks />
          </Stack>
        )}

        {lessThan1000px && (
          <Stack
            direction="column"
            spacing={8}
            sx={{ color: "white", width: "100%", maxWidth: "400px" }}
            alignItems="center"
          >
            <Stack spacing={2} paddingLeft={4} paddingRight={4}>
              <h3>{Translate.get("ECompLoginInfoTitleMobile")}</h3>
              <Box maxWidth={420}>{Translate.get("ECompLoginInfoSubtitleMobile")}</Box>
              <AppLinks paddingTop={1} />
            </Stack>
            <Box
              className="eCompPolicyInfo"
              paddingLeft={4}
              paddingRight={4}
              dangerouslySetInnerHTML={{
                __html: Translate.get("ECompPolicyInfo"),
              }}
            ></Box>
          </Stack>
        )}
      </Stack>
      {!lessThan1000px && (
        <Box
          className={"eCompPolicyInfo desktop" + (!smallHeight ? " absolute" : "")}
          paddingLeft={4}
          paddingRight={4}
          dangerouslySetInnerHTML={{
            __html: Translate.get("ECompPolicyInfo"),
          }}
        ></Box>
      )}
    </>
  );
}
